var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"introduce-wrapper"},[_c('div',{staticClass:"introduce"},[_c('img',{attrs:{"src":_vm.introducePic,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }